import TechnicalLV1 from "./1";
import TechnicalLV2 from "./2";
import TechnicalLV3 from "./3";
import TechnicalLV4 from "./4";
import TechnicalLV8 from "./8";
import TechnicalLV9 from "./9";
import TechnicalLV10 from "./10";
import TechnicalLV11 from "./11";
import TechnicalLV12 from "./12";
import TechnicalLV13 from "./13";
import TechnicalLV14 from "./14";
import TechnicalLV15 from "./15";
import TechnicalLV16 from "./16";
import TitleLabel from '../../../Assets/technical_info/title_label.png'
import TitleMarkings from '../../../Assets/technical_info/tire_sidewall_markings.png'
import TitleMoto from '../../../Assets/technical_info/title_moto.png'
import TitleMotoMarkings from '../../../Assets/technical_info/title_moto_sidewall.png'
import TitleFitment from '../../../Assets/technical_info/title_fitment.png'
import TitleWinter from '../../../Assets/technical_info/title_winter.png'
import TitleChoice from '../../../Assets/technical_info/title_choice.png'
import TitleContiseal from '../../../Assets/technical_info/title_contiseal.png'
import TitleContisilent from '../../../Assets/technical_info/title_contisilent.png'
import TitleTPMS from '../../../Assets/technical_info/tpms_icon.png'
import TitleWornTire from '../../../Assets/technical_info/title_worn_tire.png'
import TitleUse from '../../../Assets/technical_info/title_use.png'
import TitleComparison from '../../../Assets/technical_info/title_comparison.png'

const pages = [
    {
        "id": "1",
        "title": "ES Riepu marķējuma izskaidrojums",
        "image": TitleLabel,
        "description": "ES riepu marķējums palīdz vieglāk novērtēt riepas drošības un vides aspektus.",
        "contentComponent": TechnicalLV1,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2017-02-21T12:57:52",
        "updatedAt": "2020-03-04T11:32:12"
    },
    {
        "id": "2",
        "title": "Automašīnu riepu apzīmējumi",
        "image": TitleMarkings,
        "description": "Jūs vēlaties izvēlēties un iegādāties riepas savam auto, taču slikti orientējaties to apzīmējumos? Tā nav problēma! ",
        "contentComponent": TechnicalLV2,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2017-02-21T14:08:27",
        "updatedAt": "2020-02-03T08:40:16"
    },
    {
        "id": "3",
        "title": "Viss par MOTO riepām",
        "image": TitleMoto,
        "description": "Lai vadītu motociklu, jābūt ne tikai pieredzei tā vadīšanai, bet gan arī riepām, kuras esi izvēlējies. Būtisks moments ir Drošība, un drošība sākas ar riepas izvēli.\r\n",
        "contentComponent": TechnicalLV3,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2017-03-03T11:54:44",
        "updatedAt": "2020-03-04T11:36:03"
    },
    {
        "id": "4",
        "title": "MOTO riepas tehniskie parametri",
        "image": TitleMotoMarkings,
        "description": "Lai izvēlētos pareizās riepas būtu jāzin uz ko japievērš uzmanība, lai iegūtu vēlamo rezultātu!",
        "contentComponent": TechnicalLV4,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2017-03-08T10:01:50",
        "updatedAt": "2020-04-02T06:11:44"
    },
    {
        "id": "8",
        "title": "Riepu un disku saderība",
        "image": TitleFitment,
        "description": "SVARĪGI pareizi saskaņot diska platumu ar riepām. Nepareizi izvēlēts plats/šaurs disks vai riepa var ietekmēt ātru vai nevienmērīgu riepu nodilumu, kā arī pasliktināt auto vadāmību (var būt jūtama nestabilitāte braukšanas laikā).\r\n\r\n\r\n",
        "contentComponent": TechnicalLV8,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2018-02-23T08:47:53",
        "updatedAt": "2018-02-27T10:00:13"
    },
    {
        "id": "9",
        "title": "Kas jāzin par ziemas riepām",
        "image": TitleWinter,
        "description": "Ziemas riepām galvenais uzdevums ir nodrošināt labu saķeri gada aukstajos mēnešos, kad uz ceļa ir sniegs un ledus.",
        "contentComponent": TechnicalLV9,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T08:45:05",
        "updatedAt": "2020-03-04T11:29:41"
    },
    {
        "id": "10",
        "title": "Pareiza riepu un disku izvēle",
        "image": TitleChoice,
        "description": "Riepas var droši kalpot tikai tajā gadījumā, ja tās ir piemeklētas atbilstoši automobiļa specifikācijai un riepu ražotāja rekomendācijām. Disku meklētājs to var palīdzēt, bet vislabāk to izdarīs riepu , disku speciālists. Profesionāls riepus serviss mācēs konsulēt un piemeklēt pareizos diskus. ",
        "contentComponent": TechnicalLV10,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T09:03:12",
        "updatedAt": "2020-03-04T11:29:15"
    },
    {
        "id": "11",
        "title": "ContiSeal tehnoloģija- Riepas kuras nevar pārdurt",
        "image": TitleContiseal,
        "description": "Lai gan ContiSeal ievērojami samazina gaisa spiediena zudumu riepās caurduršanas gadījumā, autovadītājam jāseko līdzi jebkādām izmaiņām braukšanas dinamikā (trokšņa līmenis, vibrācija vai vadāmība). ",
        "contentComponent": TechnicalLV11,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T09:12:34",
        "updatedAt": "2020-03-04T11:09:16"
    },
    {
        "id": "12",
        "title": "ContiSilent™ tehnoloģija",
        "image": TitleContisilent,
        "description": "Klusums ir skaņa. Neatkārtojama. ContiSilent™ – riepa mazākam trokšņu līmenim.",
        "contentComponent": TechnicalLV12,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T09:27:01",
        "updatedAt": "2020-03-04T11:27:10"
    },
    {
        "id": "13",
        "title": "Riepu spiediena kontroles sistēma jeb TPMS sensori",
        "image": TitleTPMS,
        "description": "Saskaņā ar ES regulu ECE-R 64 visi jaunāko modeļu vieglie automobiļi un kemperi no 2012.gada 1.novembra jāaprīko ar TPMS (riepu spiediena kontroles sitēma jeb Tire Pressure Monitoring System). No 2014.gada 1.novembra visiem jauniem reģistrētājiem vieglajiem automobiļiem un kemperiem jābūt aprīkotiem ar TPMS. Šie saucami \"dačiki \" vai mērītāji uzlabo gan drošību gan arī riepas kalpošanas mūžu.",
        "contentComponent": TechnicalLV13,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T09:38:55",
        "updatedAt": "2020-03-04T11:26:51"
    },
    {
        "id": "14",
        "title": "Riepu kalpošanas laiks",
        "image": TitleWornTire,
        "description": "Riepu ražotāji jau sen ir atzinuši patērētāju lomu riepu regulārajā aprūpē un to uzturēšanā. Par brīdi, kurā nomainīt riepu, ir atbildīgs pats īpašnieks. Riepu īpašniekam būtu jāņem vērā faktori, kas ietver izmantošanas nosacījumus, apkopes vēsturi, uzglabāšanas apstākļus, vizuālās pārbaudes un dinamisko veiktspēju. Visos jautājumos par riepu kalpošanas laiku patērētājam būtu jākonsultējas ar riepu servisa profesionāļiem lai iegādātos nodilumizturīgas , degvielas taupošas vai lieliem ātrumiem paredžetās riepas.",
        "contentComponent": TechnicalLV14,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T10:38:43",
        "updatedAt": "2020-03-04T11:11:53"
    },
    {
        "id": "15",
        "title": "Riepu ekspluatācija",
        "image": TitleUse,
        "description": "No sākuma pastāstīsim par riepu apkopi. Kā pareizi lietot auto riepas ikdienā.",
        "contentComponent": TechnicalLV15,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-02-03T13:13:28",
        "updatedAt": "2020-03-09T08:58:50"
    },
    {
        "id": "16",
        "title": "Cik vecas drīkst būt riepas?",
        "image": TitleComparison,
        "description": "Labas riepas var droši kalpot vairākus gadus. Tas atkarīgs no braukšanas paradumiem, riepu kvalitātes, nobraukuma, riepu glabāšanas apstākļiem. Ir svarīgi laikus pamanīt faktorus, kas liecina, ka laiks iegādāties jaunas riepas.",
        "contentComponent": TechnicalLV16,
        "isPublished": true,
        "language": "lv",
        "createdAt": "2020-07-17T12:21:59",
        "updatedAt": "2020-07-17T12:22:36"
    }
];

export default pages;
